import { StyleSheet } from "react-native";

export const desktopStyles = StyleSheet.create({
  desktopPanelWrap: {
    position: "absolute",
    bottom: 16,
    left: 16,
    width: 600,
    zIndex: 20,
  },
  desktopPanel: {
    flexShrink: 1,
    borderRadius: 16,
    borderWidth: 1,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.3,
    shadowRadius: 8,
    elevation: 8,
  },
  desktopPanelContent: {
    padding: 20,
  },
  desktopAddressWrap: {
    position: "absolute",
    top: 16,
    right: 72,
    alignItems: "center",
    zIndex: 20,
  },
  desktopAddressCard: {
    position: "relative",
    top: 0,
    left: 0,
    right: 0,
    maxWidth: 440,
  },
});
